// /verify-email?token=… (FR-010 to FR-012, FR-042; P-AUTH-1). Works signed in or not.
import { VerifyEmailScreen } from "@/auth/links/VerifyEmailScreen";

export default function VerifyEmail() {
  return <VerifyEmailScreen />;
}
